export const PULS_INFO_REQUEST = "PULS_INFO_REQUEST";
export const PULS_INFO_RESULT = "PULS_INFO_RESULT";
export const PULS_INFO_SHOW_MODAL = "PULS_INFO_SHOW_MODAL";
export const PULS_INFO_HIDE_MODAL = "PULS_INFO_HIDE_MODAL";
export const PULS_FILES_REQUEST = "PULS_FILES_REQUEST";
export const PULS_FILES_RESULT = "PULS_FILES_RESULT";